import { MaterialListStatus } from '../../../types/MasterList.types';

export const statusColors = {
  [MaterialListStatus.active]: 'var(--color-light-greyish-lime-green)',
  [MaterialListStatus.ceased]: 'var(--color-light-grey-red)',
  [MaterialListStatus.added]: 'var(--color-cloud-light-blue)',
  [MaterialListStatus.deleted]: 'var(--color-soft-purple)',
  [MaterialListStatus.updated]: 'var(--color-greyish-blue)',
};
